var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('club-layout',[_c('blue-panel-date-time-picker',{on:{"apply":_vm.onApply}}),_c('div',{attrs:{"id":"container"}},[_c('table-blue-club-transfers',{attrs:{"transfers":_vm.clubTransfers}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }